import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Inject, Input, HostBinding, ElementRef, Directive, ViewChild, NgModule } from '@angular/core';
import * as i1$2 from '@taiga-ui/cdk';
import { tuiIsEdgeOlderThan, CHROMIUM_EDGE_START_VERSION, TuiResizeService, TuiDestroyService, tuiPure, tuiIsString, TuiRepeatTimesModule } from '@taiga-ui/cdk';
import { TUI_MODE, MODE_PROVIDER } from '@taiga-ui/core';
import * as i1 from 'rxjs';
import { BehaviorSubject, combineLatest, of } from 'rxjs';
import { __decorate } from 'tslib';
import { USER_AGENT, WINDOW } from '@ng-web-apis/common';
import { map, distinctUntilChanged, delay } from 'rxjs/operators';
const _c0 = ["tuiProgressBar", ""];
const _c1 = ["progressCircle"];
const _c2 = ["tuiProgressLabel", ""];
const _c3 = [[["progress"]], [["tui-progress-circle"]], "*"];
const _c4 = ["progress", "tui-progress-circle", "*"];
function TuiProgressSegmentedComponent_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 2);
  }
  if (rf & 2) {
    const index_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("background", index_r1 < ctx_r1.value ? ctx_r1.getActiveColor(index_r1) : null);
  }
}
let TuiProgressBarComponent = /*#__PURE__*/(() => {
  class TuiProgressBarComponent {
    constructor(mode$) {
      this.mode$ = mode$;
      this.size = 'm';
    }
  }
  TuiProgressBarComponent.ɵfac = function TuiProgressBarComponent_Factory(t) {
    return new (t || TuiProgressBarComponent)(i0.ɵɵdirectiveInject(TUI_MODE));
  };
  TuiProgressBarComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TuiProgressBarComponent,
    selectors: [["progress", "tuiProgressBar", ""]],
    hostVars: 3,
    hostBindings: function TuiProgressBarComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("$.data-mode.attr", function TuiProgressBarComponent___data_mode_attr_HostBindingHandler() {
          return ctx.mode$;
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("data-size", ctx.size);
        i0.ɵɵstyleProp("--tui-progress-color", ctx.color);
      }
    },
    inputs: {
      color: "color",
      size: "size"
    },
    features: [i0.ɵɵProvidersFeature([MODE_PROVIDER])],
    attrs: _c0,
    decls: 0,
    vars: 0,
    template: function TuiProgressBarComponent_Template(rf, ctx) {},
    styles: ["@keyframes _ngcontent-%COMP%_tuiIndeterminateAnimation{50%{background-position:left}}[_nghost-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;display:block;width:100%;height:var(--t-height);color:var(--tui-primary);background:var(--tui-clear);-webkit-clip-path:inset(0 round var(--tui-radius-xs));clip-path:inset(0 round var(--tui-radius-xs));overflow:hidden}[_nghost-%COMP%]::-webkit-progress-value{-webkit-transition:width var(--tui-duration) linear;transition:width var(--tui-duration) linear}[_nghost-%COMP%]::-webkit-progress-value{background:var(--tui-progress-color, currentColor)}[_nghost-%COMP%]::-moz-progress-bar{background:var(--tui-progress-color, currentColor)}[data-mode=onDark][_nghost-%COMP%]{--tui-clear: var(--tui-clear-inverse)}[data-size=m][_nghost-%COMP%]{--t-height: 1.5rem}[data-size=s][_nghost-%COMP%]{--t-height: .5rem}[data-size=s][_nghost-%COMP%]::-webkit-progress-value{border-radius:var(--tui-radius-xs)}[data-size=s][_nghost-%COMP%]::-moz-progress-bar{border-radius:var(--tui-radius-xs)}[new][_nghost-%COMP%]{-webkit-clip-path:inset(0 .5px round var(--tui-radius-m));clip-path:inset(0 .5px round var(--tui-radius-m));border-radius:1rem}[new][_nghost-%COMP%]::-webkit-progress-value{border-radius:inherit}[new][_nghost-%COMP%]::-moz-progress-bar{border-radius:inherit}[new][data-size=xs][_nghost-%COMP%]{--t-height: .25rem}[new][data-size=s][_nghost-%COMP%]{--t-height: .5rem}[new][data-size=m][_nghost-%COMP%]{--t-height: .75rem}[new][data-size=l][_nghost-%COMP%]{--t-height: 1rem}[new][data-size=xl][_nghost-%COMP%]{--t-height: 1.25rem}[new][data-size=xxl][_nghost-%COMP%]{--t-height: 1.5rem}[_nghost-%COMP%]:indeterminate{background:linear-gradient(to right,var(--tui-clear) 0 45%,var(--tui-progress-color, currentColor) 45% 55%,var(--tui-clear) 55% 100%) right;background-size:225%;animation:_ngcontent-%COMP%_tuiIndeterminateAnimation 3s infinite ease-in-out}[_nghost-%COMP%]:indeterminate::-webkit-progress-value{background:transparent}[_nghost-%COMP%]:indeterminate::-moz-progress-bar{background:transparent}[_nghost-%COMP%]::-webkit-progress-inner-element{border-radius:inherit}[_nghost-%COMP%]::-webkit-progress-bar{background:transparent;border-radius:inherit}label[tuiProgressLabel][_nghost-%COMP%]:not(:first-child), label[tuiProgressLabel]   [_nghost-%COMP%]:not(:first-child){position:absolute;top:0;left:0;width:100%;height:100%;background:transparent}"],
    changeDetection: 0
  });
  return TuiProgressBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function calculateColorSegments(colors, progressWidth) {
  const segmentWidth = Math.ceil(progressWidth / colors.length);
  const colorsString = colors.reduce((acc, color, i) => `${acc}, ${color} ${i * segmentWidth}px ${(i + 1) * segmentWidth}px`, '');
  return `linear-gradient(to right ${colorsString})`;
}
let TuiProgressColorSegmentsDirective = /*#__PURE__*/(() => {
  class TuiProgressColorSegmentsDirective {
    constructor(el, resize$, userAgent) {
      this.el = el;
      this.resize$ = resize$;
      this.userAgent = userAgent;
      // TODO: drop support of legacy Edge (EdgeHTML) in v4.x
      this.isOldBrowsers = tuiIsEdgeOlderThan(CHROMIUM_EDGE_START_VERSION, this.userAgent);
      this.colors$ = new BehaviorSubject([]);
    }
    set colors(colors) {
      this.colors$.next(colors);
    }
    get calcSegments$() {
      return combineLatest([this.colors$, this.resize$.pipe(map(() => this.el.nativeElement.offsetWidth), distinctUntilChanged())]).pipe(map(([colors, width]) => this.isOldBrowsers ? colors[0] : calculateColorSegments(colors, width)));
    }
  }
  TuiProgressColorSegmentsDirective.ɵfac = function TuiProgressColorSegmentsDirective_Factory(t) {
    return new (t || TuiProgressColorSegmentsDirective)(i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(TuiResizeService), i0.ɵɵdirectiveInject(USER_AGENT));
  };
  TuiProgressColorSegmentsDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TuiProgressColorSegmentsDirective,
    selectors: [["progress", "tuiProgressBar", "", "tuiProgressColorSegments", ""]],
    hostVars: 1,
    hostBindings: function TuiProgressColorSegmentsDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("$.style.--tui-progress-color", function TuiProgressColorSegmentsDirective___style___tui_progress_color_HostBindingHandler() {
          return 0;
        });
      }
      if (rf & 2) {
        i0.ɵɵhostProperty("$.style.--tui-progress-color", ctx.calcSegments$);
      }
    },
    inputs: {
      colors: [i0.ɵɵInputFlags.None, "tuiProgressColorSegments", "colors"]
    },
    features: [i0.ɵɵProvidersFeature([TuiDestroyService, TuiResizeService])]
  });
  __decorate([tuiPure], TuiProgressColorSegmentsDirective.prototype, "calcSegments$", null);
  return TuiProgressColorSegmentsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiProgressCircleComponent = /*#__PURE__*/(() => {
  class TuiProgressCircleComponent {
    constructor(userAgent, win, el, mode$) {
      this.userAgent = userAgent;
      this.win = win;
      this.el = el;
      this.mode$ = mode$;
      this.value = 0;
      this.max = 1;
      this.color = null;
      this.size = 'm';
      this.animationDelay$ = of(true).pipe(delay(0));
    }
    get progressRatio() {
      const ratio = this.value / this.max;
      return Number.isFinite(ratio) ? ratio : 0;
    }
    // TODO: drop support of legacy Edge (EdgeHTML) in v4.x
    get oldEdgeRadiusFallback() {
      if (!tuiIsEdgeOlderThan(CHROMIUM_EDGE_START_VERSION, this.userAgent)) {
        return null;
      }
      const strokeWidth = parseInt(this.win.getComputedStyle(this.progressCircle.nativeElement).strokeWidth, 10);
      return (this.el.nativeElement.offsetWidth - strokeWidth) / 2;
    }
  }
  TuiProgressCircleComponent.ɵfac = function TuiProgressCircleComponent_Factory(t) {
    return new (t || TuiProgressCircleComponent)(i0.ɵɵdirectiveInject(USER_AGENT), i0.ɵɵdirectiveInject(WINDOW), i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(TUI_MODE));
  };
  TuiProgressCircleComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TuiProgressCircleComponent,
    selectors: [["tui-progress-circle"]],
    viewQuery: function TuiProgressCircleComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c1, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.progressCircle = _t.first);
      }
    },
    hostVars: 5,
    hostBindings: function TuiProgressCircleComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("$.data-mode.attr", function TuiProgressCircleComponent___data_mode_attr_HostBindingHandler() {
          return ctx.mode$;
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("data-size", ctx.size);
        i0.ɵɵstyleProp("--tui-progress-color", ctx.color)("--progress-ratio", ctx.progressRatio);
      }
    },
    inputs: {
      value: "value",
      max: "max",
      color: "color",
      size: "size"
    },
    features: [i0.ɵɵProvidersFeature([MODE_PROVIDER])],
    decls: 6,
    vars: 8,
    consts: [["progressCircle", ""], [1, "t-hidden-progress", 3, "max", "value"], ["aria-hidden", "true", "height", "100%", "width", "100%", 1, "t-svg"], ["cx", "50%", "cy", "50%", 1, "t-track"], ["cx", "50%", "cy", "50%", 1, "t-progress"]],
    template: function TuiProgressCircleComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelement(0, "progress", 1);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(1, "svg", 2);
        i0.ɵɵelement(2, "circle", 3)(3, "circle", 4, 0);
        i0.ɵɵpipe(5, "async");
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("max", ctx.max)("value", ctx.value);
        i0.ɵɵadvance(2);
        i0.ɵɵattribute("r", ctx.oldEdgeRadiusFallback);
        i0.ɵɵadvance();
        i0.ɵɵclassProp("t-progress_filled", i0.ɵɵpipeBind1(5, 6, ctx.animationDelay$));
        i0.ɵɵattribute("r", ctx.oldEdgeRadiusFallback);
      }
    },
    dependencies: [i1$1.AsyncPipe],
    styles: ["[_nghost-%COMP%]{position:relative;display:block;color:var(--tui-primary);transform:rotate(-90deg);transform-origin:center;font-size:1rem;width:var(--t-diameter);height:var(--t-diameter)}[data-mode=onDark][_nghost-%COMP%]{--tui-clear: var(--tui-clear-inverse)}[data-size=s][_nghost-%COMP%]{--t-diameter: 2em;--t-track-stroke: .5em;--t-progress-stroke: .5em}[data-size=m][_nghost-%COMP%]{--t-diameter: 3em;--t-track-stroke: .375em;--t-progress-stroke: .375em}[data-size=l][_nghost-%COMP%]{--t-diameter: 4em;--t-track-stroke: .375em;--t-progress-stroke: .375em}[data-size=xl][_nghost-%COMP%]{--t-diameter: 7em;--t-track-stroke: .375em;--t-progress-stroke: .375em}[new][_nghost-%COMP%]{--t-track-stroke: var(--tui-thickness, .375em);--t-progress-stroke: var(--tui-thickness, .375em)}[new][data-size=xxs][_nghost-%COMP%]{--t-diameter: 2rem}[new][data-size=xs][_nghost-%COMP%]{--t-diameter: 2.5rem}[new][data-size=s][_nghost-%COMP%]{--t-diameter: 3.5rem}[new][data-size=m][_nghost-%COMP%]{--t-diameter: 4rem}[new][data-size=l][_nghost-%COMP%]{--t-diameter: 5rem}[new][data-size=xl][_nghost-%COMP%]{--t-diameter: 6rem}[new][data-size=xxl][_nghost-%COMP%]{--t-diameter: 8rem}.t-track[_ngcontent-%COMP%]{fill:transparent;stroke:var(--tui-clear);stroke-width:var(--t-track-stroke);r:calc((var(--t-diameter) - var(--t-track-stroke)) / 2)}.t-progress[_ngcontent-%COMP%]{fill:transparent;stroke:var(--tui-progress-color, currentColor);stroke-linecap:round;stroke-width:var(--t-progress-stroke);stroke-dasharray:calc(2 * 3.14159265 * calc((var(--t-diameter) - var(--t-progress-stroke)) / 2));stroke-dashoffset:calc(2 * 3.14159265 * calc((var(--t-diameter) - var(--t-progress-stroke)) / 2));r:calc((var(--t-diameter) - var(--t-progress-stroke)) / 2)}.t-progress_filled[_ngcontent-%COMP%]{transition:stroke-dashoffset var(--tui-duration) linear;stroke-dashoffset:calc(calc(2 * 3.14159265 * calc((var(--t-diameter) - var(--t-progress-stroke)) / 2)) - var(--progress-ratio) * calc(2 * 3.14159265 * calc((var(--t-diameter) - var(--t-progress-stroke)) / 2)))}.t-hidden-progress[_ngcontent-%COMP%]{position:absolute;clip:rect(1px,1px,1px,1px);-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;width:1px;margin:-1px;overflow:hidden;padding:0}.t-svg[_ngcontent-%COMP%]{overflow:unset}"],
    changeDetection: 0
  });
  return TuiProgressCircleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiProgressLabelComponent = /*#__PURE__*/(() => {
  class TuiProgressLabelComponent {}
  TuiProgressLabelComponent.ɵfac = function TuiProgressLabelComponent_Factory(t) {
    return new (t || TuiProgressLabelComponent)();
  };
  TuiProgressLabelComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TuiProgressLabelComponent,
    selectors: [["label", "tuiProgressLabel", ""]],
    attrs: _c2,
    ngContentSelectors: _c4,
    decls: 4,
    vars: 0,
    consts: [[1, "t-label"]],
    template: function TuiProgressLabelComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c3);
        i0.ɵɵprojection(0);
        i0.ɵɵprojection(1, 1);
        i0.ɵɵelementStart(2, "span", 0);
        i0.ɵɵprojection(3, 2);
        i0.ɵɵelementEnd();
      }
    },
    styles: ["[_nghost-%COMP%]{position:relative;display:inline-block;color:var(--tui-text-01)}.t-label[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;font:var(--tui-font-text-s);flex-direction:column;justify-content:center;align-items:center}"],
    changeDetection: 0
  });
  return TuiProgressLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @deprecated Use {@link http://taiga-ui.dev/experimental/progress-segmented TuiProgressSegmentedModule} (from `@taiga-ui/experimental`)
 * TODO: delete in v4.0
 */
let TuiProgressSegmentedComponent = /*#__PURE__*/(() => {
  class TuiProgressSegmentedComponent {
    constructor(mode$) {
      this.mode$ = mode$;
      this.value = 0;
      this.max = 1;
      this.size = 'm';
      this.colors = 'currentColor';
    }
    getActiveColor(index = 0) {
      return tuiIsString(this.colors) ? this.colors : this.colors[index] || this.colors[this.colors.length - 1];
    }
  }
  TuiProgressSegmentedComponent.ɵfac = function TuiProgressSegmentedComponent_Factory(t) {
    return new (t || TuiProgressSegmentedComponent)(i0.ɵɵdirectiveInject(TUI_MODE));
  };
  TuiProgressSegmentedComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TuiProgressSegmentedComponent,
    selectors: [["tui-progress-segmented"]],
    hostVars: 1,
    hostBindings: function TuiProgressSegmentedComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("$.data-mode.attr", function TuiProgressSegmentedComponent___data_mode_attr_HostBindingHandler() {
          return ctx.mode$;
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("data-size", ctx.size);
      }
    },
    inputs: {
      value: "value",
      max: "max",
      size: "size",
      colors: "colors"
    },
    features: [i0.ɵɵProvidersFeature([MODE_PROVIDER])],
    decls: 2,
    vars: 3,
    consts: [[1, "t-hidden-progress", 3, "max", "value"], ["aria-hidden", "true", "class", "t-segment", 3, "background", 4, "tuiRepeatTimes", "tuiRepeatTimesOf"], ["aria-hidden", "true", 1, "t-segment"]],
    template: function TuiProgressSegmentedComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelement(0, "progress", 0);
        i0.ɵɵtemplate(1, TuiProgressSegmentedComponent_span_1_Template, 1, 2, "span", 1);
      }
      if (rf & 2) {
        i0.ɵɵproperty("max", ctx.max)("value", ctx.value);
        i0.ɵɵadvance();
        i0.ɵɵproperty("tuiRepeatTimesOf", ctx.max);
      }
    },
    dependencies: [i1$2.TuiRepeatTimesDirective],
    styles: ["[_nghost-%COMP%]{display:flex;color:var(--tui-primary)}[data-mode=onDark][_nghost-%COMP%]{--tui-clear: var(--tui-clear-inverse)}.t-segment[_ngcontent-%COMP%]{transition-property:background;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;flex:1 1 100%;border-radius:var(--tui-radius-xs);background:var(--tui-clear)}.t-segment[_ngcontent-%COMP%]:not(:last-child){margin-right:.25rem}[data-size=s][_nghost-%COMP%]   .t-segment[_ngcontent-%COMP%]{height:.25rem}[data-size=m][_nghost-%COMP%]   .t-segment[_ngcontent-%COMP%]{height:.5rem}.t-hidden-progress[_ngcontent-%COMP%]{position:absolute;clip:rect(1px,1px,1px,1px);-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;width:1px;margin:-1px;overflow:hidden;padding:0}"],
    changeDetection: 0
  });
  return TuiProgressSegmentedComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiProgressModule = /*#__PURE__*/(() => {
  class TuiProgressModule {}
  TuiProgressModule.ɵfac = function TuiProgressModule_Factory(t) {
    return new (t || TuiProgressModule)();
  };
  TuiProgressModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: TuiProgressModule
  });
  TuiProgressModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, TuiRepeatTimesModule]]
  });
  return TuiProgressModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiProgressBarComponent, TuiProgressCircleComponent, TuiProgressColorSegmentsDirective, TuiProgressLabelComponent, TuiProgressModule, TuiProgressSegmentedComponent };
